import React from 'react';
import ImgHeaderVW from './recursos/imagenes/logo_vwm_header.png';
import ImgIdeasNetworking from './recursos/imagenes/logo_ideas_v2.svg';
import './recursos/css/index.css';
import ImgGrupo from './recursos/imagenes/grupo.svg';
import ImgCheck from './recursos/imagenes/check.svg';
import Carousel from './Carousel';
import ImgTuto1 from './recursos/imagenes/1.png';
import ImgTuto2 from './recursos/imagenes/2.png';
import ImgTuto3 from './recursos/imagenes/3.png';
import ImgChrome from './recursos/imagenes/chrome.svg';
import ImgFirefox from './recursos/imagenes/firefox.svg';
import ImgPcc from './recursos/imagenes/pcc.svg';
import ImgDTO from './recursos/imagenes/dto.svg';
import ImgContigo from './recursos/imagenes/contigo.svg';


function Ideas() {
    const elementosCarousel = [<div key={0} >
        <img className="containerIrIdeas__imagen" alt={''} src={ImgTuto1} />
    </div>,
    <div key={1} >
        <img className="containerIrIdeas__imagen" alt={''} src={ImgTuto2} />
    </div>,
    <div key={2} >
        <img className="containerIrIdeas__imagen" alt={''} src={ImgTuto3} />
    </div>]

    return (
        <div className="container-fluid p-0">
            <div className="header_vwm_container">
                <img src={ImgHeaderVW} alt="Logo vwm header" />
            </div>

            <div className="containerPromo text-center">
                <div className="containerPromo__imagen">
                    <img src={ImgIdeasNetworking} alt="Ideas Networking" />
                </div>
                <div className="row containerPromo__container">
                    <div className="d-flex justify-content-center justify-content-md-end col-sm-12 col-md-6">
                        <video className="containerPromo__video" src="https://dto.vwmapps.com.mx/media/video/Ideas-Promo_WEB.mp4" controls>
                        </video>
                    </div>
                    <div className="d-flex justify-content-center col-sm-12 col-md-6">
                        <div className="align-self-center">
                            <p className="containerPromo__parrafo">¡Conoce la nueva forma de compartir tus ideas y noticias!</p>
                            <a href="https://ideas.vwmapps.com.mx/vw/muro" rel="noopener noreferrer" target="_blank" className="containerPromo__boton">¡Quiero unirme ya!</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="containerVentajas text-center">
                <div className="d-flex justify-content-center">
                    <p className="containerVentajas__titulo">Ahorra tiempo y<br></br>multiplica la creatividad</p>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <img className="containerVentajas__imagen" src={ImgGrupo} alt="Ventajas" />
                    </div>
                    <div className="d-flex justify-content-start col-sm-12 col-md-6">
                        <div className="align-self-sm-start align-self-md-center containerVentajas__ventajas">
                            <div className="d-flex justify-content-start">
                                <img className="containerVentajas__imagenCheck" src={ImgCheck} alt="" />
                                <p className="containerVentajas__textoVentaja">Comparte tus ideas</p>
                            </div>
                            <div className="d-flex justify-content-start">
                                <img className="containerVentajas__imagenCheck" src={ImgCheck} alt="" />
                                <p className="containerVentajas__textoVentaja">Comparte noticias</p>
                            </div>
                            <div className="d-flex justify-content-start">
                                <img className="containerVentajas__imagenCheck" src={ImgCheck} alt="" />
                                <p className="containerVentajas__textoVentaja">Comparte, conecta e interactúa con tus compañeros</p>
                            </div>
                            <div className="d-flex justify-content-start">
                                <img className="containerVentajas__imagenCheck" src={ImgCheck} alt="" />
                                <p className="containerVentajas__textoVentaja">Administra tus ideas, noticias y mucho más…</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row containerVideoSolo">
                <div className="col-sm-12 col-md-3"></div>
                <div className="d-flex justify-content-center col-sm-12 col-md-6">
                    <video className="containerPromo__videoSolo" src="https://dto.vwmapps.com.mx/media/video/Tutorial_Final.mp4" controls>
                    </video>
                </div>
                <div className="col-sm-12 col-md-3"></div>
            </div>

            <div className="containerIrIdeas text-center">
                <div className="row containerIrIdeas__contenedor1">
                    <div className="d-flex justify-content-center justify-content-md-end col-sm-12 col-md-5">
                        <p className="containerIrIdeas__parrafo1">No te quedes atrás<br></br>¡Únete ya a esta red de ideas!</p>
                    </div>
                    <div className="col-sm-12 col-md-2"></div>
                    <div className="d-flex justify-content-center justify-content-md-start col-sm-12 col-md-5">
                        <div className="align-self-center">
                            <a href="https://ideas.vwmapps.com.mx/vw/muro" rel="noopener noreferrer" target="_blank" className="containerPromo__boton">Ir a IDEAS Networking</a>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-sm-start justify-content-md-center">
                    <p className="containerIrIdeas__texto containerIrIdeas__texto--espaciosContenedor1">¡Descárgalo ya! Es muy sencillo…</p>
                </div>

                <div className="d-flex justify-content-sm-start justify-content-md-center">
                    <p className="containerIrIdeas__texto containerIrIdeas__texto--espaciosContenedor2">· ¡Y listo!, ahora lo tendrás a la mano en tu computadora o celular</p>
                </div>
                <div className="d-flex justify-content-center">
                    <Carousel elementos={elementosCarousel} />
                </div>

                <div className="d-flex justify-content-sm-start justify-content-md-center containerIrIdeas__textoNavegadores">
                    <p className="containerIrIdeas__texto containerIrIdeas__texto--grande">Para una mejor experiencia Te recomendamos los siguientes navegadores:</p>
                </div>

                <div className="d-flex justify-content-center containerIrIdeas_imagenesNavegadores">
                    <img src={ImgChrome} alt="Chrome" />
                    <img className="containerIrIdeas__imagenFirefox" src={ImgFirefox} alt="Firefox" />
                </div>

                <div className="containerFooter">
                    <div className="row containerFooter__row">
                        <div className="d-flex justify-content-center col-sm-12 col-md-6">
                            <p className="containerFooter__texto">@Volkswagen de México {new Date().getFullYear()}</p>
                        </div>
                        <div className="d-flex flex-column flex-md-row justify-content-center col-sm-12 col-md-6">
                            <img className="containerFooter__imagen" src={ImgDTO} alt="DTO" />
                            <img className="containerFooter__imagen" src={ImgPcc} alt="PCC" />
                            <img className="containerFooter__imagen" src={ImgContigo} alt="#Contigo" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Ideas;